export default "__VITE_ASSET__946f5362__"